import { Component, OnInit } from '@angular/core';
import { ListasService, RolesService, UsuarioService } from '../../../services/service.index';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import swal2 from 'sweetalert2';
import { AwsService } from 'src/app/services/service.index';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-editarusuario',
  templateUrl: './editarusuario.component.html',
  styles: []
})
export class EditarUsuarioComponent implements OnInit {

  forma: FormGroup = new FormGroup({});
  formaRc: FormGroup = new FormGroup({});
  formaUCS: FormGroup = new FormGroup({});
  resp: any;
  listaEstatus = [];
  genero: any[];
  showModal: boolean;
  showModalNuevoFirmante: boolean;
  showModalFirmanteEmpresas: boolean;
  idu = '';
  nombre_usuario = '';
  roles: any[];
  empresa = false;
  cliente = false;
  companies = [];
  firmantes: any[];
  companies_signatories: [];
  usuario = false;
  data;
  vendedor = false;
  supervisores = [];
  // Rol del usuario logueado (quien edita). Si es Supervisor solo puede manejar Vendedores
  // y estos quedan asociados automaticamente a el.
  soySupervisor = false;

  constructor( public _usuarioService: UsuarioService,
               public http: HttpClient,
               private route: ActivatedRoute,
               private _roles: RolesService,
               public router: Router,
               private listasService: ListasService,
               private awsService: AwsService ) { }

  async ngOnInit() {
    var observableGeneros = this._usuarioService.getUserGender()
    var observableListas = this.listasService.getLists()
    var observableSupervisores = this._usuarioService.getGovSupervisorUsers()
    var observableCompanies = this.awsService.getCompanyes()

    forkJoin([observableGeneros, observableListas, observableSupervisores,  observableCompanies]).subscribe(([generos, listas, supervisores, companies]) => {
      this.genero = generos;

      listas['data'].forEach(list => {
        if(list['attributes'].domain === 'USER_STATUS'){
          this.listaEstatus.push(list['attributes']);
        }
      });

      this.supervisores = supervisores;

      this.companies = companies;

      this.cargaInicial();
    });

  }

  async mostrarAlerta() {
    const result = await swal2.fire({
      title: 'Atención',
      text: 'Para editar rol o correo, favor de contactar a soporte',
      icon: 'info',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      stopKeydownPropagation: true,
      heightAuto: false,
      timer: undefined
    });

    if (result.isConfirmed) {
      console.log('El usuario hizo clic en Aceptar');
    }
  }

  async cargaInicial(){
    // this.roles = await this._roles.getRoles().toPromise();
    this.roles = await new Promise((resolve, reject) => {
      this._roles.getRolesNotAdmin().subscribe({
        next: data => resolve(data),
        error: err => reject(err)
      });
    });

    // Determinar si el usuario logueado (quien edita) es Supervisor. Si lo es, solo puede
    // manejar roles tipo Vendedor.
    const ridLogueado = localStorage.getItem('rid');
    if (ridLogueado) {
      try {
        const rolResp: any = await new Promise((resolve, reject) => {
          this._roles.getRol(ridLogueado).subscribe({
            next: data => resolve(data),
            error: err => reject(err)
          });
        });
        const nombreRol = rolResp && rolResp[0] ? rolResp[0].name : '';
        this.soySupervisor = nombreRol === 'Supervisor Gobierno';
        if (this.soySupervisor) {
          this.roles = this.roles.filter( rol => this.esRolVendedor(rol.name) );
        }
      } catch (e) {
        console.log('No se pudo determinar el rol del usuario logueado', e);
      }
    }

    const id = this.route.snapshot.paramMap.get('id');
    this.idu = this.route.snapshot.paramMap.get('id');
    this.data = JSON.parse(localStorage.getItem('data'));
    let usuario = this.route.snapshot.paramMap.get('usuario');
    if(usuario == 'usuario'){
      this.usuario = true;
    }
    this.forma = new FormGroup({
      nombre: new FormControl( null),
      correo: new FormControl( null),
      password: new FormControl( null),
      puesto: new FormControl( null ),
      genero: new FormControl( null ),
      estatus: new FormControl( null ),
    });
    
    this.formaRc = new FormGroup({
      passwordRc: new FormControl( null , Validators.required ),
      password2Rc: new FormControl( null , Validators.required ),
    }, { validators: this.sonIguales( 'passwordRc', 'password2Rc' )  });

    this.formaUCS = new FormGroup({
      company_id: new FormControl( null , Validators.required )
    });

    this._usuarioService.getusuario( id ).subscribe( resp => {
      this.resp = resp; 
      this.nombre_usuario = this.resp[0].name
      this.selRol(); 
      this.mostrarAlerta();
    }, err => {
      console.log("ocurrio un error", err);
    }
  );
    // TRAE LOS USUARIOS FIRMANTES DESDE LA TABLA COMPANY_SIGNATORIES
    this._usuarioService.getUsuariosFirmantesEmpresa().subscribe( f => { this.firmantes = f;  })

    this._usuarioService.getUserCompanySignatories(id).subscribe( cs => { this.companies_signatories = cs; })
  }

  // Un rol es de tipo Vendedor si su nombre empieza con "Vendedor" (Yucatan, Gobierno, etc.).
  esRolVendedor(nombreRol: string): boolean {
    return !!nombreRol && nombreRol.toLowerCase().startsWith('vendedor');
  }

  // El dropdown de supervisor manual solo se muestra cuando el rol es Vendedor y quien
  // edita NO es Supervisor (si es Supervisor, la asociacion es automatica).
  get mostrarSupervisor(): boolean {
    return this.vendedor && !this.soySupervisor;
  }

  selRol(){
    var rol = this.resp[0].role_id;
    console.log(rol, this.roles)
    var name = this.roles.find(r => r.id == rol).name;
    if(name == 'Empresa'){
      this.empresa = true;
    }else{
      this.empresa = false;
    }
    if(name == 'Clientes'){
      this.cliente = true;
    }else{
      this.cliente = false;
    }
    this.vendedor = this.esRolVendedor(name);
  }

show() {
    this.showModal = true; // Show-Hide Modal Check
  }
showNuevoFirmanteEmpresa() {
    this.showModalNuevoFirmante = true; // Show-Hide Modal Check
  }
showFirmanteEmpresa() {
    this.showModalFirmanteEmpresas = true; // Show-Hide Modal Check
  }
  
hide() {
    this.showModal = false;
  }
hideNuevoFirmanteEmpresa() {
    this.showModalNuevoFirmante = false;
  }
hideFirmanteEmpresa() {
    this.showModalFirmanteEmpresas = false;
  }

sonIguales( campo1: string, campo2: string ) {

    return ( group: FormGroup ) => {

      let pass1 = group.controls[campo1].value;
      let pass2 = group.controls[campo2].value;

      if ( pass1 === pass2 ) {
        return null;
      }

      return {
        sonIguales: true
      };

    };

  }

  guardarCambios() {
    swal2.showLoading();
    // Obtener el elemento por el id
    const id = this.route.snapshot.paramMap.get('id');
    const genero: any = document.getElementById('genero');
    const estatus: any = document.getElementById('estatus');
    const nombre: any = document.getElementById('nomb');
    const email: any = document.getElementById('mail');
    const puesto: any = document.getElementById('pues');
    let rol = '';
    if(!this.usuario){
      rol = (<HTMLInputElement>document.getElementById('rol')).value;

    }
// Obtener el valor de la opción seleccionada
    const valorGenero = genero.options[genero.selectedIndex].value;
    const valorEstatus = estatus.options[estatus.selectedIndex].value;
    const valorNombre = nombre.value;
    const valorEmail = email.value;
    const valorPuesto = puesto.value;

    let firmante = '';
    try{
      firmante = (<HTMLInputElement>document.getElementById('firmante')).value;
    }catch{}
    let supervisorId = '';
    // Si quien edita es Supervisor, el Vendedor queda asociado automaticamente a el (su propio uid).
    if(this.soySupervisor){
      supervisorId = localStorage.getItem('uid') || '';
    }else{
      try{
        supervisorId = (<HTMLInputElement>document.getElementById('supervisor')).value;
      }catch{}
    }

// Obtener el texto que muestra la opción seleccionada
//    let valorSeleccionado2 = this.genero.options[this.genero.selectedIndex].text;

    if ( this.forma.invalid ) {
      return;
    }


    const params = {
      token: '',
      secret_key: '',
      auth : {
        name: valorNombre,
        email: valorEmail,
        job: valorPuesto,
        gender: valorGenero,
        status: valorEstatus,
        role_id: rol,
        company_signatory: firmante,
        user_supervisor_id: supervisorId
        
      }
    }

    this._usuarioService.actualizaUsuario(id, params).subscribe( () => {
          swal2.close();
          swal2.fire({
            title: 'El usuario',
            text: 'fue Modificado con exito',
            icon: 'success',
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false
          }). then ( res => {

            if ( res.value ) {
              this.router.navigate(['/panelcontrol/usuarios']);
            }

          } );

        }, (err) => {
          swal2.close();
          console.log(err);
          swal2.fire({
            title: 'Ocurrio un error',
            text: '',
            icon: 'error',
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false
          }). then ( res => {
            if ( res.value ) {
              this.ngOnInit();
            }
          } );
         } );
  }

  resetpassword() {

    if ( this.formaRc.invalid ) {
      return;
    }

    const params = {
      token: '',
      secret_key: '',
      password: this.formaRc.value.passwordRc
    };

    this._usuarioService.actualizaUsuarioRcPc( this.idu, params )
              .subscribe( resp => {// this.router.navigate(['/login']);
              swal2.fire(
                'Cambio de contraseña',
                'Exitosa',
                'success'
             );
              this.hide();
            }, (err) => { console.log(err);
                          swal2.fire(
                                        'Error al cambiar contraseña',
                                        'Error',
                                        'error'
                                     );
                          this.hide();
                                  }
            );


  }

  creaFirmanteEmpresa(id) {

    if ( this.formaUCS.invalid ) {
      return;
    }

    const params = {
      user_id: id,
      company_id: this.formaUCS.value.company_id
    };

    this._usuarioService.crearFirmanteEmpresa( params )
              .subscribe( resp => {
              swal2.fire(
                'Se creó el firmante de empresa',
                'Exito',
                'success'
             );
              this.hideNuevoFirmanteEmpresa();
              this.ngOnInit();
            }, (err) => { console.log(err);
                          console.clear();
                          swal2.fire(
                            "Error al crear firmante de empresa: " + err.error.errors,
                            err,
                            'error'
                            );
                          this.hideNuevoFirmanteEmpresa();
                            }
            );
  }

  eliminarFirmante(id,empresa) {
      swal2.fire({
        title: 'Eliminar',
        text: "¿Desea eliminar a " + this.nombre_usuario + " como firmante de " + empresa + "?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'No',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(result => {
        if (result.isConfirmed) {
          swal2.fire({
            title: 'Eliminando...',
            didOpen: () => swal2.showLoading(),
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false
          });

        this._usuarioService.eliminarFirmanteEmpresa(id).subscribe(r => {
          console.log(r);
          swal2.fire('Exito', 'Firmante de empresa eliminado correctamente', 'success');
          this.hideFirmanteEmpresa();
          this.ngOnInit();    })
        } else {
          this.hide();
          this.hideFirmanteEmpresa();
        }
      });

  }

}
